module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "fmcenter"
  }, [_vm._v("TO JEFF")])]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Copyright © 2017 by Susan Branson"), _c('br'), _vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Published by Familius LLC, "), _c('a', {
    staticClass: "htt",
    attrs: {
      "href": "http://www.familius.com",
      "target": "_blank"
    }
  }, [_vm._v("www.familius.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Familius books are available at special discounts for bulk purchases, whether for sales promotions or for family or corporate use. For more information, contact Familius Sales at 559-876-2170 or email "), _c('a', {
    staticClass: "htt",
    attrs: {
      "href": "mailto:orders@familius.com"
    }
  }, [_vm._v("orders@familius.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Reproduction of this book in any manner, in whole or in part,"), _c('br'), _vm._v("without written permission of the publisher is prohibited.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("DISCLAIMER: The material in this book is for informational purposes only. It is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified healthcare provider with any questions you may have regarding a medical condition or treatment. Never disregard professional medical advice or delay in seeking it because of something you have read in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("2017932168")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Print ISBN 9781945547126"), _c('br'), _vm._v("Ebook ISBN 9781945547478"), _c('br'), _vm._v("Hardcover ISBN 9781945547485")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Edited by Lindsay Sandberg")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover design by David Miles")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Book design by Brooke Jorden and David Miles")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("First Edition")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 60
// module chunks = 0